import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import JsonData from "../data/data.json";

const REGISTER_URL = `https://app.${JsonData?.Header?.nameBankDomain || "xispay"}.com.br/register`;

const SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 8000,
  arrows: true,
  adaptiveHeight: false,
  centerMode: false,
  variableWidth: false,
  pauseOnHover: true,
};

const SLIDES = [
  {
    type: "image",
    image: "/img/3slide.webp",
    title: "XisPay",
    protectedText: "Veloz. Seguro. Simples.",
    subtitle:
      "Infraestrutura de pagamentos para negócios digitais que exigem velocidade, segurança e simplicidade no dia a dia.",
  },
  {
    type: "image",
    image: "/img/header.webp",
    title: "Pagamentos em",
    protectedText: "tempo real",
    subtitle:
      "Pix, boletos, repasses e conciliação automática em uma única plataforma pensada para alta performance.",
  },
  {
    type: "image",
    image: "/img/bout.png",
    title: "A confiança",
    protectedText: "que seu negócio pede",
    subtitle:
      "Estabilidade operacional, governança e tecnologia para empresas que não podem parar — XisPay ao seu lado em cada transação.",
  },
  {
    type: "image",
    image: "/img/bank-metta.webp",
    title: "Abra sua conta",
    protectedText: "e comece hoje",
    subtitle:
      "Onboarding simples, APIs modernas e atendimento dedicado para negócios que precisam crescer com segurança.",
  },
];

const openInNewTab = () => {
  window.open(REGISTER_URL, "_blank", "noreferrer");
};

const SlideMedia = ({ slide, isActive }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const el = videoRef.current;
    if (!el || slide.type !== "video") return;
    if (isActive) {
      el.play().catch(() => {});
    } else {
      el.pause();
    }
  }, [isActive, slide.type]);

  if (slide.type === "video") {
    return (
      <video
        ref={videoRef}
        className="slide-video"
        src={slide.video}
        poster={slide.poster}
        muted
        loop
        playsInline
        preload={isActive ? "auto" : "metadata"}
        aria-label={slide.title}
      />
    );
  }

  return (
    <img
      src={slide.image}
      alt={slide.title}
      loading="lazy"
      className="slide-img"
    />
  );
};

const SlideItem = ({ slide, isActive }) => (
  <div className="slide-wrapper">
    <div className="slide-image">
      <SlideMedia slide={slide} isActive={isActive} />
      <div className="overlay">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 intro-text intro-text--hero">
              <h1 className="upp">{slide.title}</h1>
              {slide.protectedText && (
                <p className="protected-text">{slide.protectedText}</p>
              )}
              <p className="subtitle">{slide.subtitle}</p>
              <button
                type="button"
                className="btn btn-custom btn-lg"
                onClick={openInNewTab}
              >
                Abrir conta
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const Slidershow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  if (SLIDES.length === 1) {
    return (
      <div className="slideshow slideshow--hero-top">
        <SlideItem slide={SLIDES[0]} isActive />
      </div>
    );
  }

  return (
    <div className="slideshow slideshow--hero-top">
      <Slider {...SLIDER_SETTINGS} afterChange={(i) => setCurrentSlide(i)}>
        {SLIDES.map((slide, index) => (
          <SlideItem
            key={slide.video || slide.image || index}
            slide={slide}
            isActive={currentSlide === index}
          />
        ))}
      </Slider>
    </div>
  );
};
